module.exports = __webpack_public_path__ + "media/images/lb/413-5d2f9fa06277e75f15ea9caab3a04368.svg";